/**
 * İlk boyamadan ÖNCE `<html>`'e `has-auth` sınıfını ekleyen bloklayıcı script.
 *
 * Neden gerekli: home'daki kişiselleştirilebilir section'lar ISR HTML'inde
 * anonim içerikle geliyor. Girişli kullanıcıda o içeriğin yerine skeleton
 * basmak gerekiyor, ama bu kararı React'e bırakmak imkânsız — hiçbir React
 * kodu hydration'dan önce çalışamaz. HTML boyandığı an ile hydration'ın
 * bittiği an arasında anonim ürünler ekranda kalır; sonra skeleton'a düşer.
 * Gözle görülen "önce ürünler geldi, sonra skeleton çıktı" tam olarak budur.
 *
 * `<head>` içinde senkron çalıştığı için `<body>` parse edilmeden, yani ilk
 * boyamadan önce biter. Kararı CSS devralır (globals.css → `html.has-auth`),
 * React sadece veri gelince geçidi kapatır.
 *
 * `access_token` js-cookie ile yazılıyor (tokenStorage) — httpOnly değil,
 * document.cookie'den okunabilir. Burada yalnızca VARLIĞINA bakılıyor;
 * değeri okunmuyor, hiçbir yere yazılmıyor.
 *
 * Bu script bir yetkilendirme kontrolü DEĞİL: yalnızca hangi görselin
 * basılacağını seçiyor. Cookie'si elle uydurulmuş biri en fazla kendi
 * ekranında skeleton görür.
 */
export const AUTH_GATE_CLASS = "has-auth";

// `[^;\s]` şart: değeri BOŞ bir access_token cookie'si (bozuk temizlik artığı)
// varlık testini geçerdi ama tokenStorage.getAccessToken() falsy döndürürdü —
// script ile React zıt karar verir, kullanıcı sebepsiz skeleton görürdü.
export const authGateScript = `try{if(/(^|;\\s*)access_token=[^;\\s]/.test(document.cookie)){document.documentElement.classList.add('${AUTH_GATE_CLASS}')}}catch(e){}`;
